// extracted by mini-css-extract-plugin
module.exports = {"component":"text-link__Oy7O","isThemeLight":"text-link_2GKWP","isThemeDark":"text-link_2s2EA","isSimpleLink":"text-link_w68kt"};